﻿import React, { useState } from 'react';
import * as IProduct from '../Interfaces';
import { formatPrice } from '../../../helpers/Formatters';

export function ProductImage(props: { image: string }) {
    //return props.image ? (<img src={`/images/c256x144/${props.image}`} alt="product image" />) : (<div className="img-placeholder"></div>);

    return props.image ? (
        <picture>
            <source srcSet={`/images/256x144/${props.image}?fmt=webp`} type="image/webp" />
            <source srcSet={`/images/256x144/${props.image}?fmt=jpg`} type="image/jpeg" />
            <img src={`/images/256x144/${props.image}`} alt="product image" />
        </picture>) : (<div className="img-placeholder"></div>);
}

export function Price(props: { product: IProduct.Product; variant: IProduct.ProductVariant; qty?: number; priceOnly?: boolean }) {
    let price: JSX.Element;

    const qty = props.qty || props.qty === 0 ? props.qty : 1;

    if (props.variant) {
        if (props.variant.pricePerKg && !props.priceOnly) {
            price = (
                <React.Fragment>
                    <span className="p-price">{formatPrice(props.variant.price * qty)}</span >
                    <span className="p-pricePerKg text-muted small">{formatPrice(props.variant.pricePerKg, true, false)}</span>
                </React.Fragment>
            );
        }
        else if (props.variant.pricePerL && !props.priceOnly) {
            price = (
                <React.Fragment>
                    <span className="p-price">{formatPrice(props.variant.price * qty)}</span >
                    <span className="p-pricePerL text-muted small">{formatPrice(props.variant.pricePerL, false, true)}</span>
                </React.Fragment>
            );
        }
        else {
            price = (<span className="p-price">{formatPrice(props.variant.price * qty)}</span>);
        }
    }
    else { //NB legacy - currently variant will always be selected
        const min = props.product.variants.map(x => x.price).reduce((x, y) => x < y ? x : y);
        const max = props.product.variants.map(x => x.price).reduce((x, y) => x > y ? x : y);

        price = (<span className="p-price">{formatPrice(min * qty)} - {formatPrice(max * qty)}</span>);
    }

    return (
        <div className="p-pricing">
            {price}
        </div>
    );
}

export function ProductBuyer(props: { qty: number; setQty: (qty: number) => void; inStock: boolean; canEdit: boolean; shopOpen: boolean; loggedIn: boolean; preview: boolean }) {
    const [input, setInput] = useState(props.qty.toString());

    if (props.preview) {
        return (<button disabled className="btn btn-sm btn-outline-primary">Preview</button>);
    }

    if (!props.inStock) {
        return (<button disabled className="btn btn-sm btn-outline-primary">Out of Stock</button>);
    }

    if (!props.shopOpen) {
        return (<button disabled className="btn btn-sm btn-outline-primary">Shop is Closed</button>);
    }

    if (!props.loggedIn) {
        return (<button className="btn btn-sm btn-outline-primary">Login or Join</button>);
    }

    if (props.qty > 0) {
        return (<span>Qty: <input disabled={!props.canEdit} className="form-control form-control-sm d-inline-block" type="number" value={input} min={0} step={1} onBlur={() => { const val = parseInt(input, 10); if (val && props.qty !== val) props.setQty(val); if (!val && props.qty !== 0) props.setQty(0); }} onChange={(e) => { setInput(e.target.value); const val = parseInt(e.target.value, 10); if (val && val !== 0) props.setQty(Math.max(0, val)); }} /></span>);
    }
    else {
        return (<button disabled={!props.canEdit} className="btn btn-sm btn-outline-primary" onClick={() => { props.setQty(1); setInput('1'); }}>Add to Cart</button>);
    }
}

export function CartProductBuyer(props: { qty: number; setQty: (qty: number) => void; canEdit: boolean }) {
    return (<input disabled={!props.canEdit} className="form-control form-control-sm ml-1 d-inline-block" type="number" value={props.qty} min={0} step={1} onChange={(e) => { const val = parseInt(e.target.value, 10); props.setQty(isNaN(val) ? 0 : Math.max(0, val)); }} />);
}

export function ProductSelector(props: { product: IProduct.Product; variant: IProduct.ProductVariant; variantSelected: (id: number) => void }) {
    if (props.product.variants.length === 1) {
        return (<span className="p-variant-title text-muted mt-1 mb-2">{props.variant.name}</span>);
    }

    if (props.product.pricedByWeight && props.product.variants.length <= 3) { //can replace this with working out button widths from characters + variants
        const options = props.product.variants.map((v) => <button type="button" className={v.id === props.variant.id ? "p-variant active btn btn-outline-primary" : "p-variant btn btn-outline-primary"} onClick={() => props.variantSelected(v.id)}>{v.name}</button>);
        return (<div className="p-variant-options text-muted"><div className="btn-group btn-group-sm mt-1 mb-2" role="group">{options}</div></div>);
    }

    return (<select className="p-variant-selected text-muted custom-select custom-select-sm mt-1 mb-2" value={props.variant.id} onChange={(e) => { if (parseInt(e.target.value, 10)) props.variantSelected(parseInt(e.target.value, 10)); }}>
        {props.product.variants.map((v) => <option value={v.id}>{v.name}</option>)}
    </select>);
}